import React, { PureComponent } from 'react'
import { Label } from 'atoms/Texts'
import { ButtonReg } from 'atoms/Buttons'
import { FormTxt } from 'atoms/Inputs'
import {
  MainWrapper,
  ModalHead,
  ModalFooter,
  LevelRowContainer,
  InputRow
} from './styles'
import { withTheme } from 'styled-components'

export class GroupMgmtModal extends PureComponent {
  render() {
    const { theme, groupData, isDisabled, fnChange, fnSubmit, fnSwitch } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
    }

    return (
      <MainWrapper>
        <ModalHead>
          <Label lineheight={'29px'} size={'24px'} mb={'0px'}>
            {groupData.hasOwnProperty('createdAt') ? 'Edit ' : 'Add New '} Group
          </Label>
        </ModalHead>
        <LevelRowContainer>
          <InputRow>
            <Label lineheight={'14px'} size={'12px'}>
              Name
            </Label>
            <FormTxt
              placeholder={'Enter group name'}
              mb={'16px'}
              value={groupData.name}
              onChangeVal={e => fnChange(e.target.value, 'name')}
              {...inputConfig}
            />
          </InputRow>
        </LevelRowContainer>
        <ModalFooter>
          <ButtonReg onClick={fnSwitch} disabled={isDisabled} transparent btnTxt={'Cancel'} />
          <ButtonReg onClick={fnSubmit} disabled={isDisabled} btnTxt={isDisabled ? 'Submitting...' : 'Submit'} />
        </ModalFooter>
      </MainWrapper>
    )
  }
}

export default withTheme(GroupMgmtModal)
